/* Mitsubishi add-on data for Al Ubaid Motors YOM Finder. */
(function(){
  window.AUM_VEHICLE_IMAGES = window.AUM_VEHICLE_IMAGES || {};
  window.AUM_YOM_DATABASE = window.AUM_YOM_DATABASE || [];

  var imgs = `CANTER|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MITSUBISHI_CANTER.jpg?v=1784731467
DELICA D2|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MITSUBISHI_DELICA_D2.jpg?v=1784731541
DELICA D5|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MITSUBISHI_DELICA_D5.jpg?v=1784731594
DELICA MINI|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MITSUBISHI_DELICA_MINI.jpg?v=1784731646
ECLIPSE CROSS|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MITSUBISHI_ECLIPSE_CROSS.jpg?v=1784731835
EK SPACE|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MITSUBISHI_EK_SPACE.jpg?v=1784731907
EK WAGON|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MITSUBISHI_EK_WAGON.jpg?v=1784731992
EK X|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MITSUBISHI_EK_X.jpg?v=1784732044
EK X SPACE|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MITSUBISHI_EK_X_SPACE.jpg?v=1784732169
FUSO TRUCK|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MITSUBISHI_FUSO_TRUCK.jpg?v=1784732220
FUSO FIGHTER|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MITSUBISHI_FUSO_FIGHTER.jpg?v=1784732275
MINICAB MIEV|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MITSUBISHI_MINICAB_MIEV.jpg?v=1784732333
MINICAB TRUCK|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MITSUBISHI_MINICAB_TRUCK.jpg?v=1784732413
MINICAB VAN|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MITSUBISHI_MINICAB_VAN.jpg?v=1784732459
MIRAGE|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MITSUBISHI_MIRAGE.jpg?v=1784732521
OUTLANDER PHEV|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MITSUBISHI_OUTLANDER_PHEV.jpg?v=1784732589
ROSA|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MITSUBISHI_ROSA.jpg?v=1784732641
RVR|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MITSUBISHI_RVR.jpg?v=1784732683
SUPER GREAT|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MITSUBISHI_SUPER_GREAT.jpg?v=1784732781
TOWNBOX|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MITSUBISHI_TOWNBOX.jpg?v=1784732829
TRITON|https://cdn.shopify.com/s/files/1/0670/1655/6705/files/MITSUBISHI_TRITON.jpg?v=1784732869`;

  imgs.trim().split(/\n/).forEach(function(line){
    var p = line.split('|');
    if (p.length >= 2) window.AUM_VEHICLE_IMAGES['MITSUBISHI|' + p[0].trim().toUpperCase()] = p.slice(1).join('|').trim();
  });

  var rows = `MITSUBISHI	CANTER	2022	FDA60-600001	FDA60-600014
MITSUBISHI	CANTER	2023	FDA60-600016	FDA60-600283
MITSUBISHI	CANTER	2024	FDA60-600284	FDA60-610066
MITSUBISHI	CANTER	2022	FBA20-600002	FBA20-600850
MITSUBISHI	CANTER	2023	FBA20-600864	FBA20-603297
MITSUBISHI	CANTER	2024	FBA20-603298	FBA20-604286
MITSUBISHI	CANTER	2022	FBA30-600165	FBA30-600329
MITSUBISHI	CANTER	2023	FBA30-600341	FBA30-610003
MITSUBISHI	CANTER	2024	FBA30-610004	FBA30-610307
MITSUBISHI	CANTER	2022	FBA60-600001	FBA60-601669
MITSUBISHI	CANTER	2023	FBA60-601686	FBA60-604524
MITSUBISHI	CANTER	2024	FBA60-604525	FBA60-605666
MITSUBISHI	CANTER	2022	FBAV0-600001	FBAV0-600350
MITSUBISHI	CANTER	2023	FBAV0-600359	FBAV0-601335
MITSUBISHI	CANTER	2024	FBAV0-601336	FBAV0-610547
MITSUBISHI	CANTER	2022	FDA00-600001	FDA00-600192
MITSUBISHI	CANTER	2023	FDA00-600194	FDA00-600493
MITSUBISHI	CANTER	2024	FDA00-600494	FDA00-600585
MITSUBISHI	CANTER	2022	FDA20-590287	FDA20-600151
MITSUBISHI	CANTER	2023	FDA20-600152	FDA20-600486
MITSUBISHI	CANTER	2024	FDA20-600488	FDA20-600764
MITSUBISHI	CANTER	2022	FEA80-600001	FEA80-600026
MITSUBISHI	CANTER	2023	FEA80-600027	FEA80-600398
MITSUBISHI	CANTER	2024	FEA80-600399	FEA80-600535
MITSUBISHI	CANTER	2022	FEAV0-600001	FEAV0-600740
MITSUBISHI	CANTER	2023	FEAV0-600755	FEAV0-602730
MITSUBISHI	CANTER	2024	FEAV0-602731	FEAV0-603753
MITSUBISHI	CANTER	2022	FEB50-600002	FEB50-600718
MITSUBISHI	CANTER	2023	FEB50-600731	FEB50-602782
MITSUBISHI	CANTER	2024	FEB50-602783	FEB50-603860
MITSUBISHI	CANTER	2022	FEB80-600001	FEB80-600985
MITSUBISHI	CANTER	2023	FEB80-600986	FEB80-603231
MITSUBISHI	CANTER	2024	FEB80-603232	FEB80-604437
MITSUBISHI	CANTER	2022	FEB90-600001	FEB90-600652
MITSUBISHI	CANTER	2023	FEB90-600666	FEB90-602136
MITSUBISHI	CANTER	2024	FEB90-602137	FEB90-602866
MITSUBISHI	CANTER	2022	FEBM0-600001	FEBM0-600147
MITSUBISHI	CANTER	2023	FEBM0-600155	FEBM0-600370
MITSUBISHI	CANTER	2024	FEBM0-600371	FEBM0-600475
MITSUBISHI	CANTER	2022	FEA20-600001	FEA20-600114
MITSUBISHI	CANTER	2023	FEA20-600124	FEA20-600674
MITSUBISHI	CANTER	2024	FEA20-600675	FEA20-600899
MITSUBISHI	CANTER	2022	FEBS0-600001	FEBS0-600008
MITSUBISHI	CANTER	2023	FEBS0-600009	FEBS0-600165
MITSUBISHI	CANTER	2024	FEBS0-600166	FEBS0-600246
MITSUBISHI	DELICA D2	2020	MB37S-100001	MB37S-100272
MITSUBISHI	DELICA D2	2021	MB37S-100273	MB37S-102677
MITSUBISHI	DELICA D2	2022	MB37S-102678	MB37S-105201
MITSUBISHI	DELICA D2	2023	MB37S-105202	MB37S-111840
MITSUBISHI	DELICA D2	2024	MB37S-111841	MB37S-115117
MITSUBISHI	DELICA D2	2020	MB36S-753601	MB36S-754662
MITSUBISHI	DELICA D5	2020	CV1W-2202803	CV1W-2301692
MITSUBISHI	DELICA D5	2021	CV1W-2301693	CV1W-2315797
MITSUBISHI	DELICA D5	2022	CV1W-4000101	CV1W-4014586
MITSUBISHI	DELICA D5	2023	CV1W-4014587	CV1W-5003012
MITSUBISHI	DELICA D5	2024	CV1W-5003013	CV1W-5022629
MITSUBISHI	DELICA D5	2025	CV1W-5022630	CV1W-5045605
MITSUBISHI	DELICA MINI	2025	BA2A-0000001	BA2A-0004483
MITSUBISHI	DELICA MINI	2025	BA6A-0000001	BA6A-0007898
MITSUBISHI	DELICA MINI	2023	B38A-0500001	B38A-0511805
MITSUBISHI	DELICA MINI	2024	B38A-0511806	B38A-0608297
MITSUBISHI	DELICA MINI	2025	B38A-0608298	B38A-0617640
MITSUBISHI	DELICA MINI	2025	BA1A-0000001	BA1A-0004760
MITSUBISHI	DELICA MINI	2023	B34A-0500001	B34A-0507874
MITSUBISHI	DELICA MINI	2024	B34A-0507875	B34A-0610740
MITSUBISHI	DELICA MINI	2025	B34A-0610741	B34A-0623681
MITSUBISHI	DELICA MINI	2023	B35A-0500001	B35A-0506181
MITSUBISHI	DELICA MINI	2024	B35A-0506182	B35A-0606727
MITSUBISHI	DELICA MINI	2025	B35A-0606728	B35A-0614902
MITSUBISHI	DELICA MINI	2023	B37A-0500001	B37A-0503264
MITSUBISHI	DELICA MINI	2024	B37A-0503265	B37A-0603089
MITSUBISHI	DELICA MINI	2025	B37A-0603090	B37A-0606707
MITSUBISHI	ECLIPSE CROSS	2020	GK1W-0300102	GK1W-0300983
MITSUBISHI	ECLIPSE CROSS	2021	GK1W-0300984	GK1W-0303713
MITSUBISHI	ECLIPSE CROSS	2022	GK1W-0600101	GK1W-0600255
MITSUBISHI	ECLIPSE CROSS	2023	GK1W-0600256	GK1W-0700204
MITSUBISHI	ECLIPSE CROSS	2024	GK1W-0700205	GK1W-0703056
MITSUBISHI	ECLIPSE CROSS	2025	GK1W-0703057	GK1W-0707434
MITSUBISHI	ECLIPSE CROSS	2020	GL3W-0300101	GL3W-0302106
MITSUBISHI	ECLIPSE CROSS	2021	GL3W-0302107	GL3W-0307249
MITSUBISHI	ECLIPSE CROSS	2022	GL3W-0600101	GL3W-0600255
MITSUBISHI	ECLIPSE CROSS	2023	GL3W-0600256	GL3W-0700762
MITSUBISHI	ECLIPSE CROSS	2024	GL3W-0700763	GL3W-0704974
MITSUBISHI	ECLIPSE CROSS	2025	GL3W-0704975	GL3W-0708942
MITSUBISHI	EK SPACE	2020	B34A-0000001	B34A-0007796
MITSUBISHI	EK SPACE	2021	B34A-0007797	B34A-0100861
MITSUBISHI	EK SPACE	2022	B34A-0100862	B34A-0402986
MITSUBISHI	EK SPACE	2023	B34A-0402987	B34A-0507874
MITSUBISHI	EK SPACE	2024	B34A-0507875	B34A-0610740
MITSUBISHI	EK SPACE	2025	B34A-0610741	B34A-0623681
MITSUBISHI	EK SPACE	2020	B37A-0000001	B37A-0002169
MITSUBISHI	EK SPACE	2021	B37A-0002170	B37A-0100292
MITSUBISHI	EK SPACE	2022	B37A-0100293	B37A-0400883
MITSUBISHI	EK SPACE	2023	B37A-0400884	B37A-0503264
MITSUBISHI	EK SPACE	2024	B37A-0503265	B37A-0603089
MITSUBISHI	EK SPACE	2025	B37A-0603090	B37A-0606707
MITSUBISHI	EK SPACE	2020	B35A-0000001	B35A-0005067
MITSUBISHI	EK SPACE	2021	B35A-0005068	B35A-0100268
MITSUBISHI	EK SPACE	2022	B35A-0100269	B35A-0400881
MITSUBISHI	EK SPACE	2020	B11A-0417259	B11A-0417879
MITSUBISHI	EK WAGON	2020	B33W-0100001	B33W-0103235
MITSUBISHI	EK WAGON	2021	B33W-0103236	B33W-0201890
MITSUBISHI	EK WAGON	2022	B33W-0201891	B33W-0302701
MITSUBISHI	EK WAGON	2023	B33W-0302702	B33W-0402129
MITSUBISHI	EK WAGON	2024	B33W-0402130	B33W-0502942
MITSUBISHI	EK WAGON	2025	B33W-0502943	B33W-0605055
MITSUBISHI	EK WAGON	2020	B36W-0100001	B36W-0100955
MITSUBISHI	EK WAGON	2021	B36W-0100956	B36W-0200500
MITSUBISHI	EK WAGON	2022	B36W-0200501	B36W-0300810
MITSUBISHI	EK WAGON	2023	B36W-0300811	B36W-0400778
MITSUBISHI	EK WAGON	2024	B36W-0400779	B36W-0500780
MITSUBISHI	EK WAGON	2025	B36W-0500781	B36W-0501602
MITSUBISHI	EK X	2020	B34W-0100001	B34W-0100978
MITSUBISHI	EK X	2021	B34W-0100979	B34W-0200539
MITSUBISHI	EK X	2022	B34W-0200540	B34W-0300751
MITSUBISHI	EK X	2023	B34W-0300752	B34W-0400629
MITSUBISHI	EK X	2024	B34W-0400630	B34W-0500719
MITSUBISHI	EK X	2025	B34W-0500720	B34W-0600689
MITSUBISHI	EK X	2020	B37W-0100001	B37W-0100414
MITSUBISHI	EK X	2021	B37W-0100415	B37W-0200283
MITSUBISHI	EK X	2022	B37W-0200284	B37W-0300409
MITSUBISHI	EK X	2023	B37W-0300410	B37W-0400306
MITSUBISHI	EK X	2024	B37W-0400307	B37W-0500319
MITSUBISHI	EK X	2025	B37W-0500320	B37W-0600317
MITSUBISHI	EK X	2020	B38W-0100001	B38W-0100499
MITSUBISHI	EK X	2021	B38W-0100500	B38W-0200278
MITSUBISHI	EK X	2022	B38W-0200279	B38W-0300391
MITSUBISHI	EK X	2023	B38W-0300392	B38W-0400306
MITSUBISHI	EK X	2024	B38W-0400307	B38W-0500410
MITSUBISHI	EK X	2020	B35W-0100001	B35W-0100746
MITSUBISHI	EK X	2021	B35W-0100747	B35W-0200280
MITSUBISHI	EK X	2022	B35W-0200281	B35W-0300618
MITSUBISHI	EK X	2023	B35W-0300619	B35W-0400758
MITSUBISHI	EK X SPACE	2020	B37A-0000001	B37A-0002169
MITSUBISHI	EK X SPACE	2021	B37A-0002170	B37A-0100292
MITSUBISHI	EK X SPACE	2022	B37A-0100293	B37A-0400883
MITSUBISHI	EK X SPACE	2023	B37A-0400884	B37A-0503264
MITSUBISHI	EK X SPACE	2024	B37A-0503265	B37A-0603089
MITSUBISHI	EK X SPACE	2025	B37A-0603090	B37A-0606707
MITSUBISHI	EK X SPACE	2020	B34A-0000001	B34A-0007796
MITSUBISHI	EK X SPACE	2021	B34A-0007797	B34A-0100861
MITSUBISHI	EK X SPACE	2022	B34A-0100862	B34A-0402986
MITSUBISHI	EK X SPACE	2023	B34A-0402987	B34A-0507874
MITSUBISHI	EK X SPACE	2024	B34A-0507875	B34A-0610740
MITSUBISHI	EK X SPACE	2020	B35A-0000001	B35A-0005067
MITSUBISHI	EK X SPACE	2021	B35A-0005068	B35A-0100268
MITSUBISHI	EK X SPACE	2022	B35A-0100269	B35A-0400881
MITSUBISHI	EK X SPACE	2023	B35A-0400882	B35A-0506181
MITSUBISHI	EK X SPACE	2024	B35A-0506182	B35A-0606727
MITSUBISHI	EK X SPACE	2020	B38A-0000001	B38A-0002425
MITSUBISHI	EK X SPACE	2021	B38A-0002426	B38A-0100259
MITSUBISHI	EK X SPACE	2022	B38A-0100260	B38A-0400535
MITSUBISHI	EK X SPACE	2023	B38A-0400536	B38A-0511805
MITSUBISHI	FUSO TRUCK	2022	FK62F-610018	FK62F-610702
MITSUBISHI	FUSO TRUCK	2023	FK62F-610703	FK62F-620003
MITSUBISHI	FUSO TRUCK	2024	FK62F-620004	FK62F-620818
MITSUBISHI	FUSO TRUCK	2022	FK62FZ-610007	FK62FZ-610519
MITSUBISHI	FUSO TRUCK	2023	FK62FZ-610520	FK62FZ-611401
MITSUBISHI	FUSO TRUCK	2022	FK65F-610021	FK65F-610692
MITSUBISHI	FUSO TRUCK	2023	FK65F-610693	FK65F-611120
MITSUBISHI	FUSO TRUCK	2024	FK65F-620001	FK65F-620888
MITSUBISHI	FUSO TRUCK	2022	FK72F-607133	FK72F-610618
MITSUBISHI	FUSO TRUCK	2023	FK72F-610619	FK72F-620003
MITSUBISHI	FUSO TRUCK	2024	FK72F-620004	FK72F-620831
MITSUBISHI	FUSO TRUCK	2022	FK72N-610017	FK72N-610253
MITSUBISHI	FUSO TRUCK	2023	FK72N-610254	FK72N-610397
MITSUBISHI	FUSO TRUCK	2024	FS84VZ-500004	FS84VZ-500983
MITSUBISHI	FUSO TRUCK	2022	FS74HZ-540103	FS74HZ-542258
MITSUBISHI	FUSO TRUCK	2023	FS74HZ-542260	FS74HZ-547769
MITSUBISHI	FUSO TRUCK	2024	FS74HZ-547770	FS74HZ-549064
MITSUBISHI	FUSO TRUCK	2022	FV70HX-540017	FV70HX-541100
MITSUBISHI	FUSO TRUCK	2023	FV70HX-541102	FV70HX-545907
MITSUBISHI	FUSO TRUCK	2024	FV70HX-545908	FV70HX-546068
MITSUBISHI	FUSO TRUCK	2022	FU75HZ-540002	FU75HZ-540216
MITSUBISHI	FUSO FIGHTER	2022	FK62F-610018	FK62F-610702
MITSUBISHI	FUSO FIGHTER	2023	FK62F-610703	FK62F-620003
MITSUBISHI	FUSO FIGHTER	2024	FK62F-620004	FK62F-620818
MITSUBISHI	FUSO FIGHTER	2022	FK62FZ-610007	FK62FZ-610519
MITSUBISHI	FUSO FIGHTER	2023	FK62FZ-610520	FK62FZ-611401
MITSUBISHI	FUSO FIGHTER	2022	FK65F-610021	FK65F-610692
MITSUBISHI	FUSO FIGHTER	2023	FK65F-610693	FK65F-611120
MITSUBISHI	FUSO FIGHTER	2024	FK65F-620001	FK65F-620888
MITSUBISHI	FUSO FIGHTER	2022	FK72F-610022	FK72F-610622
MITSUBISHI	FUSO FIGHTER	2023	FK72F-610623	FK72F-620003
MITSUBISHI	FUSO FIGHTER	2024	FK72F-620004	FK72F-620831
MITSUBISHI	FUSO FIGHTER	2022	FK72N-610017	FK72N-610253
MITSUBISHI	FUSO FIGHTER	2023	FK72N-610254	FK72N-610397
MITSUBISHI	MINICAB MIEV	2022	U68V-0800001	U68V-0801133
MITSUBISHI	MINICAB MIEV	2023	U68V-0801134	U68V-0801778
MITSUBISHI	MINICAB TRUCK	2020	DS16T-521055	DS16T-524439
MITSUBISHI	MINICAB TRUCK	2021	DS16T-524440	DS16T-641048
MITSUBISHI	MINICAB TRUCK	2022	DS16T-641049	DS16T-692529
MITSUBISHI	MINICAB TRUCK	2023	DS16T-692530	DS16T-695137
MITSUBISHI	MINICAB TRUCK	2024	DS16T-695138	DS16T-821766
MITSUBISHI	MINICAB TRUCK	2025	DS16T-821767	DS16T-824261
MITSUBISHI	MINICAB VAN	2020	DS17V-423016	DS17V-426560
MITSUBISHI	MINICAB VAN	2021	DS17V-426561	DS17V-571640
MITSUBISHI	MINICAB VAN	2022	DS17V-571641	DS17V-613934
MITSUBISHI	MINICAB VAN	2023	DS17V-613935	DS17V-617307
MITSUBISHI	MINICAB VAN	2024	DS17V-617308	DS17V-891156
MITSUBISHI	MINICAB VAN	2025	DS17V-891157	DS17V-894776
MITSUBISHI	MIRAGE	2020	A03A-0050251	A03A-0052515
MITSUBISHI	MIRAGE	2021	A03A-0052516	A03A-0055266
MITSUBISHI	MIRAGE	2022	A03A-0055267	A03A-0057993
MITSUBISHI	MIRAGE	2023	A03A-0057994	A03A-0058554
MITSUBISHI	OUTLANDER PHEV	2021	GN0W-0100101	GN0W-0102676
MITSUBISHI	OUTLANDER PHEV	2022	GN0W-0102677	GN0W-0304335
MITSUBISHI	OUTLANDER PHEV	2023	GN0W-0304336	GN0W-0400706
MITSUBISHI	OUTLANDER PHEV	2024	GN0W-0400707	GN0W-0504413
MITSUBISHI	OUTLANDER PHEV	2025	GN0W-0504414	GN0W-0602100
MITSUBISHI	OUTLANDER PHEV	2020	GG3W-0702508	GG3W-0800401
MITSUBISHI	OUTLANDER PHEV	2021	GG3W-0800402	GG3W-0801810
MITSUBISHI	ROSA	2021	BE740G-100473	BE740G-200114
MITSUBISHI	ROSA	2022	BE740G-200115	BE740G-200762
MITSUBISHI	ROSA	2023	BE740G-250002	BE740G-250881
MITSUBISHI	ROSA	2024	BE740G-250882	BE740G-400545
MITSUBISHI	RVR	2020	GA4W-5300001	GA4W-5300903
MITSUBISHI	RVR	2021	GA4W-5300904	GA4W-5400918
MITSUBISHI	RVR	2022	GA4W-5400919	GA4W-5401727
MITSUBISHI	RVR	2024	GA4W-5600540	GA4W-5601199
MITSUBISHI	SUPER GREAT	2024	FP84VD-500002	FP84VD-500351
MITSUBISHI	SUPER GREAT	2022	FV70HY-540004	FV70HY-540282
MITSUBISHI	SUPER GREAT	2023	FV70HY-540284	FV70HY-540364
MITSUBISHI	SUPER GREAT	2022	FV70HX-540017	FV70HX-541100
MITSUBISHI	SUPER GREAT	2023	FV70HX-541102	FV70HX-541389
MITSUBISHI	TOWNBOX	2020	DS17W-250001	DS17W-250252
MITSUBISHI	TOWNBOX	2021	DS17W-250253	DS17W-250585
MITSUBISHI	TOWNBOX	2022	DS17W-300001	DS17W-300413
MITSUBISHI	TOWNBOX	2023	DS17W-300414	DS17W-301003
MITSUBISHI	TOWNBOX	2024	DS17W-301004	DS17W-301052
MITSUBISHI	TRITON	2024	LC2T-0000201	LC2T-0004790
MITSUBISHI	TRITON	2025	LC2T-0004791	LC2T-0007258`;

  var existing = {};
  window.AUM_YOM_DATABASE.forEach(function(r){
    existing[[r.make, r.name, r.year, r.start, r.end].join('|')] = true;
  });

  rows.trim().split(/\n/).forEach(function(line){
    var p = line.trim().split(/\t+|\s{2,}/).filter(Boolean);
    if (p.length < 5) return;
    var make = p[0].trim().toUpperCase();
    var name = p[1].trim().toUpperCase().replace(/\s+/g, ' ');
    var year = parseInt(p[2], 10);
    var start = p[3].trim().toUpperCase();
    var end = p[4].trim().toUpperCase();
    var chassis = start.split('-')[0];
    var endChassis = end.split('-')[0];
    var frameFrom = parseInt(start.split('-')[1], 10);
    var frameTo = parseInt(end.split('-')[1], 10);
    var key = [make, name, year, start, end].join('|');
    if (make !== 'MITSUBISHI' || chassis !== endChassis || isNaN(year) || isNaN(frameFrom) || isNaN(frameTo) || frameTo < frameFrom || existing[key]) return;
    existing[key] = true;
    window.AUM_YOM_DATABASE.push({ make: make, name: name, chassis: chassis, start: start, end: end, frameFrom: frameFrom, frameTo: frameTo, year: year });
  });
})();